<template>
  <div :class="$style.container">
    <div :class="$style.mainContent">
      <div :class="$style.header">
        <div :class="$style.headerContent">
          <div :class="$style.breadcrumbs">
            <div :class="$style.text">Commercial Pilot 2024</div>
            <div>|</div>
            <b :class="$style.pageTitle">Create Lesson</b>
          </div>
        </div>
      </div>
      <div :class="$style.backButton" @click="navigateBack">
        <img
          :class="$style.backIcon"
          alt=""
          src="/static/img/LeftChevron.svg"
        />
      </div>
    </div>
    <div :class="$style.lessonSection">
      <div :class="$style.createLessonParent">
        <b :class="$style.text">Create Lesson</b>
        <div :class="$style.gradedParent"></div>
      </div>
      <div
        :class="$style.lessonSection1"
        :style="{
          gridTemplateColumns: `${isEdit ? '4fr 4fr 1fr' : '1fr 1fr'}`,
        }"
      >
        <input
          :class="$style.valueInput25"
          type="number"
          placeholder="Time..."
          v-model="form.time"
          :disabled="loading"
        />
        <input
          :class="$style.valueInput25"
          type="number"
          placeholder="Debrief..."
          v-model="form.debrief"
          :disabled="loading"
        />
        <div :class="$style.mainIcons" v-if="isEdit">
          <img
            style="margin-right: 15px"
            alt=""
            src="/static/img/Trash.svg"
            @click="deleteLesson"
          />
          <img
            alt=""
            src="/static/img/duplicate.svg"
            @click="duplicateLesson"
          />
        </div>
      </div>
      <div :class="$style.itemParent">
        <div :class="$style.text">Lesson Title</div>
        <div :class="$style.itemWrapper">
          <input
            :class="$style.valueInputFull"
            type="text"
            placeholder="Title..."
            v-model="form.title"
            :disabled="loading"
          />
        </div>
      </div>
      <div :class="$style.itemParent">
        <div :class="$style.text">Lesson Type</div>
        <div :class="$style.itemWrapper">
          <hilo-select
            :options="lessonTypes"
            style="width: 100%; height: 100%"
            :searchable="true"
            :disabled="loading"
            v-model="form.lessonType"
          ></hilo-select>
        </div>
      </div>
      <div :class="$style.itemParent">
        <div :class="$style.text">Lesson Objective</div>
        <div :class="$style.itemWrapper">
          <input
            :class="$style.valueInputFull"
            type="text"
            placeholder="Write Description..."
            :disabled="loading"
            v-model="form.description"
          />
        </div>
      </div>
    </div>
    <div
      :class="$style.lessonSection2"
      v-if="shownSections.includes('references')"
    >
      <div :class="$style.referenceMaterialsWrapper">
        <b :class="$style.referenceMaterials">Reference Material</b>
      </div>
      <div :class="$style.lessonAssignementsParent">
        <div :class="$style.lessonMaterialsWrapper">
          <div :class="$style.text">Lesson Materials</div>
        </div>
        <div :class="$style.header1">
          <div :class="$style.lessonSection4">
            <div
              :class="$style.itemWrapper"
              v-for="(reference, referenceIndex) of referenceMaterials"
              v-bind:key="referenceIndex"
            >
              <input
                :class="$style.valueInputFull"
                type="text"
                v-model="reference.description"
                placeholder="Reference..."
                @input="
                  updateReference(
                    reference,
                    referenceIndex,
                    'referenceMaterials',
                  )
                "
                :disabled="loading"
              />
              <img
                v-if="referenceMaterials.length > 1"
                :class="$style.rightIcon"
                alt=""
                src="/static/img/Trash.svg"
                @click="
                  removeItemFromArray(
                    reference,
                    referenceMaterials,
                    'referenceMaterials',
                  )
                "
              />
            </div>
          </div>
        </div>
        <div :class="$style.itemWrapper">
          <div
            :class="$style.addText"
            @click="addItemToArray(referenceMaterials, 'referenceMaterials')"
          >
            + Add Material
          </div>
        </div>
      </div>
    </div>
    <div
      :class="$style.lessonSection5"
      v-if="shownSections.includes('elements')"
    >
      <div :class="$style.lessonElementsWrapper">
        <b :class="$style.referenceMaterials">Lesson Elements</b>
      </div>
      <div
        :class="$style.element1Parent"
        v-for="(element, elementIndex) of elements"
        v-bind:key="elementIndex"
      >
        <div :class="$style.itemWrapper">
          <b :class="$style.text">Element {{ elementIndex + 1 }}</b>
          <img
            v-if="elements.length > 1"
            :class="$style.rightIcon"
            alt=""
            src="/static/img/Trash.svg"
            @click="removeItemFromArray(element, elements, 'elements')"
          />
        </div>
        <div
          :class="$style.itemWrapper"
          v-for="(standard, standardIndex) of element.standards"
          v-bind:key="standardIndex"
        >
          <input
            :class="$style.valueInputFull"
            type="text"
            v-model="standard.description"
            placeholder="Type here..."
            :disabled="loading"
            @input="
              updateReference(standard, standardIndex, 'elementStandards')
            "
          />
          <img
            v-if="element.standards.length > 1"
            :class="$style.rightIcon"
            alt=""
            src="/static/img/Trash.svg"
            @click="
              removeItemFromArray(
                standard,
                element.standards,
                'elementStandards',
              )
            "
          />
        </div>
        <div
          :class="$style.addStandard"
          @click="addItemToArray(element.standards, 'elementStandards')"
        >
          + Add Standard
        </div>
      </div>
      <div :class="$style.itemWrapper">
        <div
          :class="$style.addText"
          @click="addItemToArray(elements, 'elements')"
        >
          + Add Lesson Element
        </div>
      </div>
    </div>
    <div
      :class="$style.lessonSection"
      v-if="shownSections.includes('standards')"
    >
      <div :class="$style.lessonStandardsWrapper">
        <b :class="$style.referenceMaterials">Lesson Standards</b>
      </div>
      <div :class="$style.itemParent">
        <div :class="$style.text">Lesson Standards</div>
        <div
          :class="$style.itemWrapper"
          v-for="(standard, standardIndex) of lessonStandards"
          v-bind:key="standardIndex"
        >
          <input
            :class="$style.valueInputFull"
            type="text"
            v-model="standard.description"
            placeholder="Type here..."
            :disabled="loading"
            @input="updateReference(standard, standardIndex, 'lessonStandards')"
          />
          <img
            v-if="lessonStandards.length > 1"
            :class="$style.rightIcon"
            alt=""
            src="/static/img/Trash.svg"
            @click="
              removeItemFromArray(standard, lessonStandards, 'lessonStandards')
            "
          />
        </div>
      </div>
      <div :class="$style.itemWrapper">
        <div
          :class="$style.addText"
          @click="addItemToArray(lessonStandards, 'lessonStandards')"
        >
          + Add Additional Standards
        </div>
      </div>
    </div>
    <div
      :class="$style.lessonSection2"
      v-if="shownSections.includes('assignments')"
    >
      <div :class="$style.referenceMaterialsWrapper">
        <b :class="$style.referenceMaterials">Lesson Assignments</b>
      </div>
      <div :class="$style.lessonAssignementsParent">
        <div :class="$style.text" v-if="lessonAssignments.length">
          Lesson Assignments
        </div>
        <div
          :class="$style.itemWrapper"
          v-for="assignment of lessonAssignments"
          v-bind:key="assignment.id"
        >
          <div :class="$style.text">{{ assignment.name }}</div>
          <div :class="$style.mainIcons">
            <img
              style="margin-right: 15px"
              alt=""
              src="/static/img/Maintenance.svg"
              @click="
                navigateToPage(
                  'Create Assignment',
                  {},
                  {
                    type: 'edit',
                    assignmentId: assignment.id,
                  },
                )
              "
            />
            <img
              alt=""
              src="/static/img/Trash.svg"
              @click="
                removeItemFromArray(
                  assignment,
                  lessonAssignments,
                  'lessonAssignments',
                )
              "
            />
          </div>
        </div>
        <div :class="$style.itemWrapper">
          <div :class="$style.addText" @click="addAssignment">
            + Add Assignments
          </div>
          <!-- <div style="margin-left: 55%" :class="$style.addText" >
            + Create New Assignment
          </div> -->
        </div>
      </div>
    </div>
    <div
      :class="$style.lessonSection"
      v-if="shownSections.includes('regulations')"
    >
      <div :class="$style.lessonStandardsWrapper">
        <b :class="$style.referenceMaterials">Regulatory Requirements</b>
      </div>
      <div :class="$style.itemParent">
        <div :class="$style.text">Certificate</div>
        <div :class="$style.itemWrapper">
          <hilo-select
            v-model="selectedCertificate"
            :options="certificates"
            style="width: 100%; height: 100%"
            :disabled="loading"
            :searchable="true"
          ></hilo-select>
        </div>
      </div>
      <div :class="$style.itemParent">
        <div :class="$style.text">Regulations Taught</div>
        <div :class="$style.itemWrapper">
          <hilo-select
            v-model="taughtRegulations"
            :options="regulations"
            style="width: 100%; height: 100%"
            :disabled="loading"
            :searchable="true"
            :multi-select="true"
          ></hilo-select>
        </div>
      </div>
    </div>
    <div :class="$style.lessonSection9">
      <div :class="$style.itemWrapper" style="width: 50%">
        <hilo-select
          v-model="shownSections"
          :options="sections"
          style="width: 100%; height: 100%"
          :searchable="true"
          :disabled="loading"
          :multi-select="true"
          placeholder="Add Element"
        ></hilo-select>
      </div>
      <div :class="$style.saveAssignmentWrapper" @click="save">
        <b :class="$style.text">Save Lesson</b>
      </div>
    </div>
    <div :class="$style.frameInner" />
    <ToastNotifier ref="toast" />
  </div>
</template>
<script>
import { Switch } from "element-ui";
import HiloSelect from "../../../../components/HiloComponents/HiloSelect.vue";
import { useFormStore } from "../../../../stores/formStore.js";
import { mapState, mapActions } from "pinia";
import ToastNotifier from "@/components/ToastNotifier.vue";
import AssignmentsAPIService from "../../../../servicehandlers/AssignmentsAPIService.js";
import LessonsAPIService from "../../../../servicehandlers/LessonsAPIService";
const assignmentService = new AssignmentsAPIService();
const lessonsAPIService = new LessonsAPIService();

export default {
  name: "Frame",
  components: {
    HiloSelect,
    [Switch.name]: Switch,
    ToastNotifier,
  },
  data() {
    return {
      form: {},
      shownSections: [],
      sections: [
        {
          id: "references",
          name: "Reference Material",
        },
        {
          id: "elements",
          name: "Lesson Elements",
        },
        {
          id: "standards",
          name: "Lesson Standards",
        },
        {
          id: "assignments",
          name: "Lesson Assignments",
        },
        // {
        //   id: "regulations",
        //   name: "Regulatory Requirements",
        // },
      ],
      lessonTypes: [],
      possibleAssignments: [],
      referenceMaterials: [],
      elements: [],
      lessonStandards: [],
      selectedAssignments: [],
      lessonAssignments: [],
      elementStandards: [],
      certificates: [],
      regulations: [],
      selectedCertificate: null,
      taughtRegulations: [],
      loading: false,
      lesson: null,
    };
  },
  watch: {
    shownSections(newVal) {
      this.setShownSections(newVal);
    },
    selectedAssignments(newVal) {
      this.setLessonAssignments(newVal);
    },
    lessonAssignments: {
      handler(newVal) {
        const hasProps = newVal.filter((assignment) => {
          return Object.entries(assignment).length !== 0;
        });

        if (JSON.stringify(hasProps) !== JSON.stringify(newVal))
          this.lessonAssignments = hasProps;
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {
    if (this.assignmentPayload.length === 0) {
      this.clearLessonPersistent();
    }
    await this.getLessonTypes();
    try {
      this.possibleAssignments = await assignmentService.getAllAssignments(
        this.$router,
      );

      if (this.isEdit) {
        this.setAssignmentPayload([]);
        this.loading = true;

        this.lesson = await lessonsAPIService.getLessonById(
          this.$route.query.lessonId,
          this.$router,
        );

        this.form = {
          title: this.lesson.name,
          lessonType: this.lesson.lessonTypeId,
          description: this.lesson.description,
          debrief: this.lesson.debrief,
          time: this.lesson.time,
        };

        if (this.lesson.assignments.length) {
          this.shownSections.push("assignments");
          this.lessonAssignments = this.lesson.assignments.map(
            (assignment) => ({
              id: assignment.id,
              name: assignment.name,
            }),
          );
          Object.assign(this.form, {
            assignments: this.lesson.assignments,
          });
        }
        if (this.lesson.lessonReferences.length) {
          this.shownSections.push("references");
          this.referenceMaterials = this.lesson.lessonReferences.map(
            (reference) => ({
              description: reference.description,
            }),
          );
        }
        if (this.lesson.lessonElements.length) {
          this.shownSections.push("elements");
          this.elements = this.lesson.lessonElements.map((element) => ({
            standards: element.elementStandards.map((standard) => ({
              description: standard.description,
            })),
          }));
        }
        if (this.lesson.lessonStandards.length) {
          this.shownSections.push("standards");
          this.lessonStandards = this.lesson.lessonStandards.map(
            (standard) => ({
              description: standard.description,
            }),
          );
        }
      } else {
        this.form = this.formData;
        this.shownSections = this.cardSections;
        this.selectedAssignments = this.lessonAssignmentsData;

        this.cardSectionsData = this.$global.deepCopy(this.cardSectionsData);

        const standardKeys = Object.keys(this.cardSectionsData);
        for (let key of standardKeys) {
          this[key] = this.cardSectionsData[key];
        }
      }

      if (this.assignmentPayload.length) {
        this.lessonAssignments = this.assignmentPayload;
      }
    } catch (error) {
      this.$refs.toast.showError(error.message);
    } finally {
      this.loading = false;
    }
  },
  computed: {
    ...mapState(useFormStore, [
      "formData",
      "cardSections",
      "cardSectionsData",
      "lessonAssignmentsData",
      "assignmentPayload",
    ]),
    isEdit() {
      return this.$route.query.lessonId;
    },
  },
  methods: {
    ...mapActions(useFormStore, [
      "setFormData",
      "setShownSections",
      "setCardSectionsData",
      "clearLessonPersistent",
      "setLessonAssignments",
      "setAssignmentPayload",
      "clearAssignmentPayload",
    ]),
    addAssignment() {
      if (!this.isEdit) {
        this.setAssignmentPayload(this.lessonAssignments);
        this.$router.push({
          path: "/hilo/curriculumTemplates/courseDetails/createAssignment",
          query: {
            fromCreateLesson: true,
            curriculumStageId: this.$route.query.curriculumStageId,
            curriculumId: this.$route.query.curriculumId,
          },
        });
      } else {
        this.setAssignmentPayload([]);
        this.navigateToPage(
          "Create Assignment",
          {},
          {
            curriculumStageId: this.$route.query.curriculumStageId,
            saveAssignment: true,
            curriculumId: this.$route.query.curriculumId,
          },
        );
      }
    },
    async duplicateLesson() {
      try {
        this.loading = true;
        await lessonsAPIService.duplicateLesson(
          this.$route.query.lessonId,
          this.$router,
        );
        this.$refs.toast.showSuccess(this.form.title + " has been duplicated.");
        setTimeout(() => {
          this.loading = false;
          this.navigateBack();
        }, 1000);
      } catch (error) {
        this.$refs.toast.showError(error.message);
      }
    },
    async deleteLesson() {
      try {
        this.loading = true;
        await lessonsAPIService.deleteLesson(
          this.$route.query.lessonId,
          this.$router,
        );
        this.clearLessonPersistent();
        this.$refs.toast.showSuccess(this.form.title + " has been deleted.");
        setTimeout(() => {
          this.loading = false;
          this.navigateBack();
        }, 1000);
      } catch (error) {
        this.$refs.toast.showError(error.message);
      }
    },
    getLessonTypes() {
      return lessonsAPIService
        .getAllLessonTypes(this.$router)
        .then((response) => {
          this.lessonTypes = response;
        });
    },
    updateReference(reference, index, prop) {
      this[prop][index] = reference;
      this.setCardSectionsData({ [prop]: this[prop] });
    },
    navigateBack() {
      this.$router.go(-1);
    },
    navigateToPage(name, params, query) {
      this.setFormData(this.form);
      this.$router.push({
        name: name,
        params: params,
        query,
      });
    },
    async removeItemFromArray(item, array, type) {
      let index = array.indexOf(item);
      array.splice(index, 1);
      this.setCardSectionsData({ [type]: array });

      if (type === "lessonAssignments") {
        this.setAssignmentPayload(array);
        if (item.id) {
          await assignmentService.deleteAssignment(item.id, this.$router);
        }
      }
    },
    addItemToArray(array, type) {
      let temp = {};
      let skip = false;
      switch (type) {
        case "referenceMaterials":
        case "elementStandards":
          temp = {
            description: "",
          };
          break;
        case "elements":
          temp = {
            standards: [
              {
                description: "",
              },
            ],
          };
          break;
        case "lessonStandards":
          temp = {
            description: "",
          };
          break;
        case "lessonAssignments":
          // skip = true;
          for (let id of this.selectedAssignments) {
            for (let assignment of this.possibleAssignments) {
              if (assignment.id === id) {
                if (!this.lessonAssignments.includes(assignment)) {
                  this.lessonAssignments.push(assignment);
                }
              }
            }
          }
          this.selectedAssignments = [];
          break;
      }
      if (!skip) {
        array.push(temp);
        this.setCardSectionsData({ [type]: array });
      }
    },
    async save() {
      try {
        this.loading = true;
        let temp = {
          curriculumStageId:
            this.$route.query.curriculumStageId ||
            this.lesson.curriculumStageId,
          lessonTypeId: this.form.lessonType,
          name: this.form.title,
          description: this.form.description,
          assignments: this.lessonAssignments,
          references: this.referenceMaterials,
          elements: this.elements,
          standards: this.lessonStandards,
          debrief: this.form.debrief,
          time: this.form.time,
        };

        const requiredFields = Object.keys(temp).filter((x) => !temp[x]);
        const validations =
          this.$global.createMultipleValidations(requiredFields);

        if (
          this.shownSections.includes("assignments") &&
          !temp.assignments.length
        )
          validations.push(
            `${!validations.length ? " Add" : " Add also"} at least one assignment`,
          );

        if (
          this.shownSections.includes("references") &&
          (!temp.references.length ||
            temp.references.some((data) => data.description === ""))
        ) {
          validations.push(
            `${!validations.length ? " Add" : " Also add"} at least one reference`,
          );
        }

        if (
          this.shownSections.includes("elements") &&
          (!temp.elements.length ||
            temp.elements.some((data) =>
              data.standards.some((item) => item.description === ""),
            ))
        ) {
          validations.push(
            `${!validations.length ? " Add" : " Also add"} at least one element and element standard`,
          );
        }

        if (
          this.shownSections.includes("standards") &&
          (!temp.standards.length ||
            temp.standards.some((data) => data.description === ""))
        ) {
          validations.push(
            `${!validations.length ? " Add" : " Also add"} at least one standard`,
          );
        }

        if (validations.length) {
          this.$refs.toast.showError(validations);
          return;
        }

        if (this.isEdit) {
          temp.assignments = temp.assignments.map((assignment) => ({
            id: assignment.id,
            name: assignment.name,
          }));
          await lessonsAPIService.updateLesson(
            this.$route.query.lessonId,
            temp,
            this.$router,
          );
        } else await lessonsAPIService.createLesson(temp, this.$router);

        this.form = {};
        this.lessonAssignments = [];
        this.clearLessonPersistent();
        this.$refs.toast.showSuccess(
          `Lesson ${this.isEdit ? "updated" : "created"} successfully`,
        );

        setTimeout(() => {
          this.navigateToPage(
            "Course Details",
            {},
            { curriculumId: this.$route.query.curriculumId },
          );
        }, 1000);
      } catch (error) {
        this.$refs.toast.showError(error.message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style module scoped>
.breadcrumbs {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.frameChild {
  align-self: stretch;
  width: 1px;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
}

.pageTitle {
  position: relative;
  color: #404040;
}

.headerContent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.header {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
  z-index: 0;
}

.backIcon {
  width: 16px;
  position: relative;
  height: 16px;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: contain;
}

.backButton {
  margin: 0 !important;
  position: absolute;
  top: 2px;
  left: 0;
  background-color: #f6f6f6;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 20px;
  z-index: 1;
}

.mainContent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 50px;
  position: relative;
  gap: 20px;
  font-size: 25px;
  color: rgba(64, 64, 64, 0.5);
}

.vectorIcon {
  width: 24px;
  position: relative;
  height: 23px;
}

.text {
  position: relative;
}

.addText {
  position: relative;
  cursor: pointer;
}

.vectorParent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.getStartedWrapper {
  align-self: stretch;
  border-radius: 10px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 15px;
  font-size: 15px;
  color: #d701ff;
}

.aiSection {
  width: 900px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background: linear-gradient(90deg, #2200ff, #ea00ff);
  overflow-y: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  box-sizing: border-box;
  font-size: 20px;
  color: #fff;
}

.frameItem {
  position: absolute;
  top: calc(50% - 13px);
  right: 2px;
  border-radius: 100px;
  background-color: #fff;
  width: 26px;
  height: 26px;
}

.rectangleWrapper {
  width: 50px;
  position: relative;
  border-radius: 100px;
  background-color: #00a551;
  height: 30px;
  overflow: hidden;
  flex-shrink: 0;
}

.gradedParent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
  font-size: 15px;
}

.createLessonParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 40px;
}

.valueInput25 {
  flex: 1;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
}

.valueInput25:disabled {
  background: #f6f6f6;
}

.valueInput25,
.valueInputFull {
  background: #fff;
}

.valueInputFull {
  flex: 1;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  width: 100%;
}

.rightIcon {
  width: 24px;
  position: absolute;
  right: 15px;
  height: 24px;
  overflow: hidden;
  flex-shrink: 0;
}

img {
  cursor: pointer;
}

.mainIcons {
  width: 63px;
  position: absolute;
  right: 0;
  height: 24px;
  overflow: hidden;
  flex-shrink: 0;
}

.lessonSection1 {
  position: relative;
  align-self: stretch;
  height: 50px;
  display: grid;
  gap: 20px;
  align-items: center;
  /* flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start; */
  width: 100%;
  color: rgba(64, 64, 64, 0.75);
}

.itemWrapper {
  align-self: stretch;
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  color: rgba(64, 64, 64, 0.75);
  position: relative;
}

.itemParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}

.vectorIcon1 {
  width: 13.3px;
  position: relative;
  height: 7.7px;
}

.selectParent {
  align-self: stretch;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid #d5d5d5;
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
  color: #707070;
}

.lessonSection {
  width: 900px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 50px 75px;
  box-sizing: border-box;
  gap: 25px;
}

.lessonSection2 {
  width: 900px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 50px 75px;
  box-sizing: border-box;
  gap: 25px;
  font-size: 22px;
}

.referenceMaterials {
  flex: 1;
  position: relative;
}

.referenceMaterialsWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.lessonMaterialsWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 5px;
}

.far6165Parent {
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
}

.lessonSection4 {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}

.header1 {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}

.lessonElementsWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: #404040;
}

.typeHereWrapper {
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
}

.addStandard {
  align-self: stretch;
  position: relative;
  right: 0;
  color: rgba(64, 64, 64, 0.75);
  text-align: right;
  cursor: pointer;
}

.element1Parent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  color: #404040;
}

.addStandard1 {
  align-self: stretch;
  position: relative;
  text-align: right;
}

.element2Parent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
}

.addLessonElementWrapper {
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 47px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
}

.lessonSection5 {
  width: 900px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 50px 75px;
  box-sizing: border-box;
  gap: 25px;
  color: rgba(64, 64, 64, 0.75);
}

.lessonStandardsWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

.addAdditionalStandardsWrapper {
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 47px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
  color: rgba(64, 64, 64, 0.75);
}

.lessonAssignementsParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  font-size: 15px;
}

.commercialCertificateParent {
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
  color: rgba(64, 64, 64, 0.75);
}

.addElementParent {
  flex: 1;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.15);
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  box-sizing: border-box;
}

.saveAssignmentWrapper {
  flex: 1;
  border-radius: 10px;
  background-color: #3c78ff;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
}

.lessonSection9 {
  width: 900px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  font-size: 18px;
}

.frameInner {
  width: 100px;
  position: relative;
  background-color: #f6f6f6;
  height: 100px;
  overflow: hidden;
  flex-shrink: 0;
}

.container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 25px 0px 0px;
  box-sizing: border-box;
  gap: 25px;
  text-align: left;
  font-size: 15px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
</style>
